import { RootState, IRootState } from "../root-state.store";
import { IDocumentService, DocumentService } from "../../services";
import { ActivityStatus } from "../../common/enums";
import { IDocumentListingViewmodel, IDocumentTypeListingViewmodel, IDocumentModel, IDocumentParamter, DocumentParamter } from "../../models/documents";
import { DOCUMENT_LOADERS } from "./document-types.store";
import { DocumentDto, IDocument } from "../../models/documents/document";

export interface IDocumentState extends IRootState<IDocumentService> {
  document?: IDocument
  documentModel?: IDocument
  documents?: IDocumentListingViewmodel[];
  sidebarDocuments?: IDocumentListingViewmodel[];
  documentTypes?: IDocumentTypeListingViewmodel[]
  documentParameter?: IDocumentParamter
  sidebarDocumentsActivityStatus?: ActivityStatus;
  sidebarDocumentTypeActivityStatus?: ActivityStatus;
  removeActivityStatus?: ActivityStatus;
  pagination?: { page: number, total_pages: number, total:number };
  documentSelection?: number[]
}

export class DocumentState extends RootState implements IDocumentState {
  /**
   *
   */
  document?: IDocument
  documents: IDocumentListingViewmodel[];
  sidebarDocuments?: IDocumentListingViewmodel[];
  documentTypes?: IDocumentTypeListingViewmodel[]
  documentParameter?: IDocumentParamter
  sidebarDocumentsActivityStatus?: ActivityStatus;
  sidebarDocumentTypeActivityStatus?: ActivityStatus;
  removeActivityStatus?: ActivityStatus;
  pagination?: { page: number, total_pages: number, total:number  }
  documentSelection?: number[]
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity, service: new DocumentService });
    this.document = new DocumentDto({})
    this.documents = [];
    this.documentTypes = [];
    this.sidebarDocuments = [];
    this.documentParameter= new DocumentParamter
    this.sidebarDocumentsActivityStatus = ActivityStatus.NoActivity;
    this.sidebarDocumentTypeActivityStatus = ActivityStatus.NoActivity;
    this.removeActivityStatus = ActivityStatus.NoActivity;
    this.pagination = {
      page: 1,
      total_pages: 0,
      total:0
    }
    this.documentSelection=[]
    this.loaders= new Map([
      [DOCUMENT_LOADERS.FILTERS_LOADER,false],
      [DOCUMENT_LOADERS.TABLE_LOADER,false],
      [DOCUMENT_LOADERS.CATEGORIES_LOADER,false]
    ])
  }
}



// WEBPACK FOOTER //
// ./src/store/document/document-state.store.ts